<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2022-04-18 15:06:39
 * @LastEditors: 诺
 * @LastEditTime: 2022-12-09 09:53:11
-->

<template>
  <div class="boxMian" v-if="configInfo">
    <div class="page-wrapper" :style="{ backgroundImage: `url('${configInfo.backgroundImg}')` }">
      <div class="kv"><img :src="configInfo.mainKvImg" /></div>
      <BaseBottom :configInfo="configInfo" />
      <ActBaseBtnHome :bColor="configInfo.buttonBackgroundColour" :textColor="configInfo.buttonTextColour" url='coupon'/>

      <div class="model" :style="{ backgroundColor: `${configInfo.mainColour}80` }">
        <div class="modelTitle" :style="{
          backgroundColor: configInfo.mainColour,
          color: configInfo.buttonTextColour,
        }">
          · 规则说明 ·
        </div>

        <div class="modelBg">
          <div class="rule">
            <p class="MsoNormal " style="margin-left: 0cm; text-indent: 0cm; mso-list: l0 level1 lfo1; ">
              <!-- [if !supportLists]--><strong style="mso-bidi-font-weight: normal; "><span lang="EN-US " style="mso-bidi-font-size: 10.5pt; font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑; color: black;
                  mso-themecolor: text1; mso-fareast-language: ZH; "><span
                    style="mso-list: Ignore; ">1、</span></span></strong>
              <!--[endif]--><span class="s1 "><span style="mso-bidi-font-size: 10.5pt; font-family: '微软雅黑' ,sans-serif;
                  mso-bidi-font-family: 微软雅黑; color: black; mso-themecolor: text1; ">活动期间，玩家可在会场内花费<span
                    lang="EN-US ">9.9</span>元购买购房优惠券。因不同项目优惠内容不同，购买时需注意优惠券所对应的项目<strong style="mso-bidi-font-weight:
                    normal; ">【购房优惠券的优惠额度及使用时间以各项目的使用规则为准】</strong>。购买成功后，即可获取使用凭证</span></span><span class="s1 "><span
                  lang="ZH " style="mso-bidi-font-size: 10.5pt; font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑;
                  color: black; mso-themecolor: text1; mso-fareast-language: ZH; ">。</span></span><span
                class="s1 "><span style="mso-bidi-font-size: 10.5pt; font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑; color: black;
                  mso-themecolor: text1; ">使用时</span></span><span class="s1 "><span lang="ZH " style="mso-bidi-font-size:
                  10.5pt; font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑; color: black; mso-themecolor: text1;
                  mso-fareast-language: ZH; ">请参照各项目优惠券</span></span><span class="s1 "><span style="mso-bidi-font-size: 10.5pt;
                  font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑; color: black; mso-themecolor:
                  text1; ">的使用规则，并于此券使用有效期内到</span></span><span class="s1 "><span lang="ZH " style="mso-bidi-font-size: 10.5pt;
                  font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑; color: black; mso-themecolor: text1;
                  mso-fareast-language: ZH; ">指定领奖地址</span></span><span class="s1 "><span style="mso-bidi-font-size: 10.5pt;
                  font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑; color: black; mso-themecolor:
                  text1; ">进行使用核销，逾期无效。</span></span>
            </p>
            <p class="MsoNormal " style="margin-left: 0cm; text-indent: 0cm; mso-list: l0 level1 lfo1; ">
              <!-- [if !supportLists]--><strong style="mso-bidi-font-weight: normal; "><span lang="EN-US " style="mso-bidi-font-size: 10.5pt; font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑; color: black;
                  mso-themecolor: text1; mso-fareast-language: ZH; "><span
                    style="mso-list: Ignore; ">2、</span></span></strong>
              <!--[endif]--><span class="s1 "><span style="mso-bidi-font-size: 10.5pt; font-family: '微软雅黑' ,sans-serif;
                  mso-bidi-font-family: 微软雅黑; color: black; mso-themecolor:
                  text1; ">该购房优惠券无法作为购房定金优惠使用，仅限客户缴纳购房首付款或缴纳购房全款时按本购房优惠券对应的优惠金额进行相应优惠。</span></span>
            </p>
            <p class="MsoNormal " style="margin-left: 0cm; text-indent: 0cm; mso-list: l0 level1 lfo1; ">
              <!-- [if !supportLists]--><strong style="mso-bidi-font-weight: normal; "><span lang="EN-US " style="mso-bidi-font-size: 10.5pt; font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑; color: black;
                  mso-themecolor: text1; mso-fareast-language: ZH; "><span
                    style="mso-list: Ignore; ">3、</span></span></strong>
              <!--[endif]--><span class="s1 "><span style="mso-bidi-font-size: 10.5pt; font-family: '微软雅黑' ,sans-serif;
                  mso-bidi-font-family: 微软雅黑; color: black; mso-themecolor:
                  text1; ">使用此购房优惠券时，可叠加使用其他优惠（若有），但一套房屋只能使用一张购房优惠券，不能多次使用，不能折现、兑现、变现或返现；</span></span>
            </p>
            <p class="MsoNormal " style="margin-left: 0cm; text-indent: 0cm; mso-list: l0 level1 lfo1; ">
              <!-- [if !supportLists]--><strong style="mso-bidi-font-weight: normal; "><span lang="EN-US " style="mso-bidi-font-size: 10.5pt; font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑; color: black;
                  mso-themecolor: text1; mso-fareast-language: ZH; "><span
                    style="mso-list: Ignore; ">4、</span></span></strong>
              <!--[endif]--><span class="s1 "><span style="mso-bidi-font-size: 10.5pt; font-family: '微软雅黑' ,sans-serif;
                  mso-bidi-font-family: 微软雅黑; color: black; mso-themecolor:
                  text1; ">成功购买并消费使用本购房优惠券后，若遇其他情形导致无法购房需要退款时，此购房优惠券可按购买价格退还客户（退款<span
                    lang="EN-US ">9.9</span>元）；</span></span><span lang="ZH " style="mso-bidi-font-size: 10.5pt;
                font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑; color: black; mso-themecolor: text1;
                mso-fareast-language: ZH; ">如需发起优惠券退款，可添加活动中的企业微信或联系项目电话进行登记。退款将在</span><span lang="EN-US " style="mso-bidi-font-size: 10.5pt; font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑; color: black;
                mso-themecolor: text1; mso-fareast-language: ZH; ">3</span><span lang="ZH " style="mso-bidi-font-size: 10.5pt;
                font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑; color: black; mso-themecolor: text1;
                mso-fareast-language: ZH; ">个工作日内原路返回； </span>
            </p>
            <p class="MsoNormal " style="margin-left: 0cm; text-indent: 0cm; mso-list: l0 level1 lfo1; ">
              <span class="s1 "><span style="mso-bidi-font-size: 10.5pt; font-family: '微软雅黑' ,sans-serif;
                  mso-bidi-font-family: 微软雅黑; color: black; mso-themecolor: text1; ">本次活动由</span></span><span
                class="s1 "><span lang="ZH " style="mso-bidi-font-size: 10.5pt; font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑;
                  color: black; mso-themecolor: text1; mso-fareast-language: ZH; ">远洋集团</span></span><span
                class="s1 "><span style="mso-bidi-font-size: 10.5pt; font-family: '微软雅黑' ,sans-serif; mso-bidi-font-family: 微软雅黑; color: black;
                  mso-themecolor: text1; ">在法律法规范围内保留最终解释权。</span></span>
            </p>
            <div v-html="rule"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from "vue/dist/vue.js";
// import Grid from "./components/grid";
// import Pointer from "./components/pointer";
// import ButtonList from "./components/buttonList";
// import { getUserInfo2 } from "@/http/rushi-wx";
import util from "@/utils/common";

// const statusTipMap = {
//   0: "该活动无效",
//   1: "该活动待发布",
//   2: "该活动未上线",
//   4: "该活动已下线",
//   5: "该活动已下线",
// };

export default {
  components: {},
  props: {},

  data() {
    return {
      configInfo: {}, //配置信息
      id: 0,
      rule:''
    };
  },

  mounted() {
    this.id = this.$route.params.id
    this.initAct();
    if (this.$configInfo.shareSwitch != 1) {
      this.$wx.hideOptionMenu();
    }
  },
  methods: {
    // 页面配置
    async initAct() {
      this.configInfo = this.$configInfo
      const rule = [
        { id: 0, rule: `北京国誉万和城<br/>1、此购房优惠券仅限购买车位使用，请在使用期限内出示此券并由北京国誉万和城审核通过后方可使用，逾期无效；<br/>2、优惠券有效期为即日起至12月30日18点` },
        { id: 1, rule: `廊坊光华城<br/>1、此优惠券仅限抵扣二期住宅物业费使用（自办理入住后第二年起使用），请在有效期限内出示此券并由廊坊远洋光华城审核通过后方可使用，逾期无效；<br/>2、优惠券有效期为即日起至2022年12月30日18点` },
        { id: 3, rule: `石家庄风景长安<br/>1、此购房优惠券仅限购买二期住宅产品使用，请在有效期限内出示此券并由石家庄远洋风景长安审核通过后方可使用，逾期无效；<br/>2、优惠券有效期为即日起至2022年12月31日18点` },
        { id: 4, rule: `太原万和四季<br/>1、此购房优惠券仅限购买太原远洋万和四季二期住宅产品使用，请在有效期限内出示此券并由太原远洋万和四季审核通过后方可使用，逾期无效；<br/>2、优惠券有效期为即日起至2022年12月31日18点` },
        { id: 5, rule: `大连塔河湾<br/>1、此购房优惠券仅限购买叠拼产品使用，不可兑换现金，请在使用期限内出示此券并由远洋·塔河湾审核通过后方可使用，逾期无效；<br/>2、特价房源不参与此活动；<br/>3、优惠券有效期为即日起至2022年12月30日18点。` },
        { id: 6, rule: '济南潮起东方<br/>此购房优惠券仅限购买住宅使用，请在使用期限内出示此券并由济南潮起东方审核通过后方可使用，逾期无效；优惠券有效期为即日起至2022年12月30日18点。<br/> <br/>济南凤栖翰林: <br/>此购房优惠券仅限购买住宅产品使用（特价房源不参与），请在使用期限内出示此券并由济南远洋凤栖翰林项目审核通过后方可使用，逾期无效；优惠券有效期为即日起至2022年12月30日18点 <br/> <br/>济南湖印都会: <br/>此购房优惠券仅限购买住宅产品使用（特价房源不参与），请在使用期限内出示此券并由济南湖印都会项目审核通过后方可使用，逾期无效；优惠券有效期为即日起至2022年12月30日18点。<br/><br/>济南万和公馆: <br/>此购房优惠券仅限购买住宅使用，请在使用期限内出示此券并由济南万和公馆审核通过后方可使用，逾期无效；优惠券有效期为即日起至2022年12月30日18点。<br/>' },
        { id: 7, rule: `青岛万和云璟<br/>此购房优惠券仅限购买住宅产品使用（特价房源不参与），请在使用期限内出示此券并由青岛远洋万和云璟项目审核通过后方可使用，逾期无效；优惠券有效期为即日起至2022年12月14日18点。<br/><br/>青岛万和城<br/>此购房优惠券仅限购买公寓使用，请在使用期限内出示此券并由青岛远洋万和城审核通过后方可使用，逾期无效；优惠券有效期为即日起至2022年12月30日18点。<br/><br/>青岛山水<br/>1、此购房优惠券仅限购买远洋山水住宅使用，不可兑换现金，请在使用期限内出示此券并由远洋·山水审核通过后方可使用，逾期无效；<br/>2、特价房源不参与此活动；<br/>3、优惠券有效期使用日期为即日起至2022年12月18日` },
        { id: 8, rule: `沈阳上河风景<br/><br/>此购房优惠劵仅限购买车位使用，请在使用期内出示此劵并由沈阳上河风景项目审核通过后方可使用，逾期无效：优惠卷使用有效期为即日起至2022年12月30日18点。<br/>沈阳鲲栖府<br/><br/>此购房优惠券仅限购买住宅产品使用（特价房源不参与），请在使用期限内出示此券并由沈阳远洋鲲栖府项目审核通过后方可使用，逾期无效；优惠券有效期为即日起至2022年12月14日18点。` },
        { id: 9, rule: `天津未来城住宅<br/>此购房优惠券仅限购买住宅使用，请在使用期限内出示此券并由天津未来城审核通过后方可使用，逾期无效；优惠券有效期为即日起至2022年12月30日18点。<br/><br/>天津博屿海<br/>此购房优惠券仅限购买住宅产品使用（特价房源不参与），请在使用期限内出示此券并由天津远洋博屿海项目审核通过后方可使用，逾期无效；优惠券有效期为即日起至2022年12月14日18点。<br/><br/>天津寛阅时光<br/>此购房优惠券仅限购买住宅使用，请在使用期限内出示此券并由天津寛阅时光审核通过后方可使用，逾期无效；优惠券有效期为即日起至2022年12月30日18点。<br/><br/>天津潮起东方<br/>此购房优惠券仅限购买住宅使用，请在使用期限内出示此券并由天津潮起东方审核通过后方可使用，逾期无效；优惠券有效期为即日起至2022年12月30日18点。` },
        { id: 10, rule: `苏州风景东方<br/>1、此购房优惠券仅限购买本案在售住宅使用，请在使用期限内出示此券并由苏州远洋风景东方审核通过后方可使用，逾期无效；<br/>2、优惠券有效期为即日起至12月30日18点<br/><br/>苏州万和悦<br/>1、此购房优惠券仅限购买本案在售洋房产品使用，请在使用期限内出示此券并由苏州远洋万和悦审核通过后方可使用，逾期无效；<br/>2、优惠券有效期为即日起至12月30日18点` },
        { id: 11, rule: `温州四季宸章<br/>1、此购房优惠券仅限购买本案在售住宅使用，请在使用期限内出示此券并由温州州远洋四季宸章审核通过后方可使用，逾期无效；<br/>2、优惠券有效期为即日起至12月12日21点<br/><br/>温州山海万和<br/>1、此购房优惠券仅限购买车位使用，请在使用期限内出示此券并由远洋山海万和审核通过后方可使用，逾期无效；<br/>2、优惠券有效期为即日起至12月12日21点<br/><br/>温州万和樾<br/>1、此购房优惠券仅限购买车位使用，请在使用期限内出示此券并由远洋万和樾审核通过后方可使用，逾期无效；<br/>2、优惠券有效期为即日起至12月12日21点` },
        { id: 12, rule: `无锡慧聚拾光<br/>1、此购房优惠券仅限购买无锡慧聚拾光项目在售住宅产品使用；<br/>2、需在使用期限内，认购付款前出示此券，并由无锡慧聚拾光项目审核通过后方可使用，逾期无效；<br/>2、优惠券有效期为即日起至2022年12月30日21：00前` },
        { id: 13, rule: `丹阳爱家尚城<br/>1、此购房优惠券仅限购买本案在售住宅产品使用，请在使用期限内出示此券并由丹阳远洋心里项目审核通过后方可使用，逾期无效；<br/>2、优惠券有效期为即日起至2022年12月28日21：00前` },
        { id: 14, rule: `合肥星悦<br/>1、此购房优惠券仅限购买住宅使用（特价房除外），请在使用期限内出示此券并由远洋星悦项目审核通过后方可使用，逾期无效；<br/>2、优惠券有效期为即日起至12月30日18点` },
        { id: 15, rule: `南昌靖淞云璟<br/>截止12月30日18:00前使用<br/>一口价房源不参与<br/><br/>南昌天著<br/>截止12月30日18:00前使用` },
        { id: 16, rule: `武汉东方境世界观住宅<br/>截止12月30日18:00前使用<br/><br/>武汉远洋国际中心<br/>12月30日18:00前用` },
        { id: 17, rule: `郑州沁山水<br/>截止12月30日18:00前使用<br/><br/>郑州臻园<br/>截止12月30日18:00前使用` },
        { id: 18, rule: `成都森海境<br/>截止12月30日18:00前使用` },
        { id: 19, rule: `贵阳万和世家 <br/>截止12月30日18:00前使用 ` },
        { id: 20, rule: `` },
        { id: 21, rule: `西安未央華府<br/>截止12月30日18:00前使用` },
        { id: 22, rule: `佛山风景<br/>截止12月30日<br/><br/>佛山天成<br/>截止12月30日18:00前使用` },
        { id: 23, rule: `福州天赋<br/>截止12月30日` },
        { id: 24, rule: `广州天成<br/>截止12月30日<br/><br/>广州风景<br/>截止12月31日24:00前使用` },
        { id: 25, rule: `江门云著<br/>截至12月30日<br/><br/>江门天成<br/>截止12月31日24:00前使用` },
        { id: 26, rule: `茂名山水<br/>截止12月31日24:00前使用` },
        { id: 27, rule: `厦门风景<br/>截止12月30日24:00前使用` },
        { id: 28, rule: `湛江远洋城<br/>截止12月31日24:00前使用（已成交及特价房源除外）` },
        { id: 29, rule: `中山山水<br/>截止12月31日24:00前使用（已签约及特价房除外）<br/><br/>中山天著<br/>截止12月31日24:00前使用（已成交及特价房源除外）<br/> <br/>中山天成<br/>截止12月31日24:00前使用（已成交及特价房源除外）<br/><br/>中山繁花里<br/>截止12月31日24:00前使用（已成交及特价房源除外）` },


      ]
this.rule=rule.filter(item=>item.id==this.id)[0].rule
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

.boxMian {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(90deg, #930710, #c90e24);

  .page-wrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-bottom: 120px;

    .kv {
      width: 295px;
      margin: 40px auto 0;

      img {
        max-width: 100%;
        height: auto;
      }
    }

    .model {
      width: 351px;
      margin: 16px auto 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 12px;
      box-sizing: border-box;
      box-shadow: 0px 0px 12px rgba(172, 3, 40, 0.3);
      background-color: rgba(255, 255, 255, 0.1);
      padding: 10px;
      border: 1px solid rgba(255, 255, 255, 0.1);

      .modelTitle {
        position: absolute;
        margin-top: -10px;
        color: white;
        padding: 0 20px;
        line-height: 40px;
        height: 40px;
        text-align: center;
        border-radius: 6px;
        display: inline-block;
        font-weight: bold;
        z-index: 1;
        font-size: 20px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
        border-radius: 0px 0px 12px 12px;
      }

      .modelBg {
        width: 100%;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 7px;
        padding: 40px 20px 20px;

        .rule {
          word-break: break-all;
          overflow-y: auto;
          font-size: 14px;
          line-height: 160%;
        }
      }
    }
  }
}
</style>
